import React from 'react';
function OpenCaisse() {
    return ( <> CAFE SGHAIRI AYMEN </> );
}

export default OpenCaisse;